import general from '../assets/services/general-dentistry.png';
import cosmetic from '../assets/services/cosmetic.JPG';
import tech from '../assets/services/endodontics.JPG';
import prosthodontics from '../assets/services/prosthodontics.JPG';
import implants from '../assets/implant.jpg';
import orthodontics from '../assets/services/orthodontic.JPG';
import emergency from '../assets/services/emergency-dental-care.JPG';
import periodontics from '../assets/periodontics-in-nds.jpg';
import toothExtract from '../assets/services/oral-and-maxillofacial-surgery.JPG';
import main from '../assets/main.JPG';
import pediatric from '../assets/services/pediatric-dentistry.JPG';
import robot from '../assets/services/advanced-care.JPG';
import nextgen from '../assets/services/next-gen-dentistry.png';
const SERVICE_IMAGES = {
  general: general,
  cosmetic: cosmetic,
  endodontics: tech,
  prosthodontics: prosthodontics,
  implants: implants,
  orthodontics: orthodontics,
  omfs: toothExtract,
  pediatric: pediatric,
  periodontics: periodontics,
  emergency: emergency,
  advanced: robot,
  nextgen: nextgen,
};

const IMAGE_LEFT_IDS = new Set(['general', 'endodontics', 'pediatric', 'emergency', 'nextgen']);

const RAW_SERVICES = [
  {
    id: 'general',
    title: 'General Dentistry',
    chip: 'General Dentistry',
    subtitle: 'Comprehensive Dental Care for All Ages',
    accentColor: '#1565C0',
    color: '#1565C0',
    dotColor: '#00C9A7',
    icon: '🦷',
    duration: '30–60 min',
    paragraphs: [
      'General dentistry forms the foundation of lifelong oral health. At Noble Dental Surgery, our general dentistry services cover the full spectrum of preventive, diagnostic, and restorative care — ensuring every patient leaves healthier than they arrived.',
      'From dental check-ups to Digital X-rays and in-house OPG facility to professional cleanings and fillings to extractions and dentures, our experienced general dentists handle every common dental concern with precision and care.',
      'Our patient-centred approach means we take time to understand your dental history, concerns, and goals. Every treatment plan is personalised, explained clearly, and carried out with your comfort as the priority.',
    ],
    benefits: [
      'Preventive cleanings every 6 months',
      'White composite fillings matching natural tooth colour',
      'Full and partial dentures crafted for comfort',
      'Safe, painless extractions with aftercare',
      'Night guards for bruxism and teeth grinding',
      'Oral cancer screening at every check-up',
    ],
    process: [
      { step: 'Comprehensive Examination', desc: 'Full clinical and radiographic assessment of all teeth and gums.' },
      { step: 'Personalised Treatment Plan', desc: 'Prioritised plan with clear costs presented before any work begins.' },
      { step: 'Preventive Care', desc: 'Professional cleaning, scaling, and fluoride application.' },
      { step: 'Restorative Treatment', desc: 'Fillings, extractions, or dentures as clinically indicated.' },
      { step: 'Review & Recall', desc: 'Scheduled recall to maintain results and monitor oral health.' },
    ],
  },
  {
    id: 'cosmetic',
    title: 'Cosmetic Dentistry',
    chip: 'Cosmetic Dentistry',
    subtitle: 'Smile Design & Aesthetic Treatments',
    color: '#6A1B9A',
    accentColor: '#6A1B9A',
    dotColor: '#00C9A7',
    icon: '💎',
    duration: 'Varies',
    paragraphs: [
      'Cosmetic dentistry at Noble Dental Surgery is a blend of art and science. Our cosmetic team analyses facial proportions, gum architecture, tooth shape, colour, and symmetry to design smiles that look completely natural and feel uniquely yours.',
      'We offer the full suite of cosmetic treatments — ultra-thin porcelain/Emax veneers, cosmetic bonding, professional teeth whitening, gum contouring, and comprehensive smile makeovers that combine multiple procedures for a total transformation.',
      'Every cosmetic plan begins with a digital smile design preview, so you can visualise your result and provide feedback before any irreversible step is taken.',
    ],
    benefits: [
      'Porcelain/Emax veneers for perfect shape and shade',
      'Cosmetic bonding for chips, cracks, and gaps',
      'In-chair whitening up to 3-4 shades brighter',
      'Gum contouring for a balanced smile line',
      'Digital smile preview before treatment starts',
      'Minimally invasive techniques wherever possible',
    ],
    process: [
      { step: 'Smile Analysis', desc: 'Photographs, scans, and detailed wish list reviewed.' },
      { step: 'Digital Design', desc: 'Smile mockup created digitally for your approval.' },
      { step: 'Trial Smile', desc: 'Temporary composite placed to preview the result in real life.' },
      { step: 'Preparation', desc: 'Minimal enamel reduction to accommodate veneers or crowns.' },
      { step: 'Final Bonding', desc: 'Permanent restorations bonded, polished, and bite-adjusted.' },
    ],
  },
  {
    id: 'endodontics',
    title: 'Endodontics',
    chip: 'Endodontics',
    subtitle: 'Root Canal Specialists',
    color: '#2E7D32',
    accentColor: '#2E7D32',
    dotColor: '#1565C0',
    icon: '🔬',
    duration: '60–90 min',
    paragraphs: [
      'Endodontics is the specialty focused on diagnosing and treating diseases of the dental pulp and root canal system. At Noble Dental Surgery, our endodontists use advanced technology to save teeth that would otherwise require extraction. We practice complete aseptic technique with world class B-tye autoclaves. ',
      'Modern root canal treatment is virtually painless. Using rotary instrumentation, digital apex locators, and CBCT 3D imaging, we can complete most cases in a single visit with exceptional accuracy and minimal post-operative discomfort.',
      'Beyond standard root canals, we perform retreatment of failed root canals, apicectomy (surgical root end treatment), and pulp capping — a conservative approach that preserves living pulp tissue in suitable cases.',
    ],
    benefits: [
      'Virtually painless with advanced anaesthesia',
      'Most cases completed in a single appointment',
      'CBCT 3D imaging for precise canal mapping',
      'Retreatment of previously failed root canals',
      'Apicectomy for persistent periapical infections',
      'High long-term tooth survival rate',
    ],
    process: [
      { step: '3D CBCT Scan', desc: 'Root canal anatomy mapped in three dimensions before starting.' },
      { step: 'Deep Anaesthesia', desc: 'Tooth fully numbed — treatment is completely pain-free.' },
      { step: 'Pulp Removal', desc: 'Infected or inflamed pulp carefully removed from all canals.' },
      { step: 'Canal Shaping', desc: 'Rotary instruments enlarge and shape canals for thorough cleaning.' },
      { step: 'Obturation', desc: 'Canals filled with biocompatible gutta-percha and sealed.' },
    ],
  },
  {
    id: 'prosthodontics',
    title: 'Prosthodontics',
    chip: 'Prosthodontics',
    subtitle: 'Crowns, Bridges, Dentures & Full Mouth Rehabilitation',
    color: '#0097A7',
    accentColor: '#0097A7',
    dotColor: '#2ECC71',
    icon: '🦴',
    duration: '2–4 visits',
    paragraphs: [
      'Prosthodontics is the specialty dedicated to restoring and replacing teeth to full function and aesthetics. Our prosthodontists at Noble Dental Surgery are trained to manage everything from a single crown to complete full-mouth rehabilitation.',
      'We use the latest CAD/CAM technology and work with premium dental laboratories to fabricate restorations — crowns, bridges, veneers, and dentures — that are indistinguishable from natural teeth in appearance, feel, and longevity.',
      'Full mouth rehabilitation combines multiple restorative and cosmetic procedures to completely rebuild a worn, broken, or missing dentition. Cases are planned comprehensively before any preparation begins.',
    ],
    benefits: [
      'Metal-free zirconia and e.max crowns',
      'Implant-supported bridges and dentures',
      'Full mouth rehabilitation for worn dentitions',
      'CAD/CAM same-day crowns available',
      'Precision-fit removable partial and full dentures',
      'Occlusal equilibration for TMJ-related issues',
    ],
    process: [
      { step: 'Diagnostic Records', desc: 'Study models, photos, and bite analysis taken.' },
      { step: 'Treatment Planning', desc: 'Digital wax-up and comprehensive plan presented.' },
      { step: 'Tooth Preparation', desc: 'Teeth shaped to receive crowns or bridges precisely.' },
      { step: 'Temporaries', desc: 'Temporary restorations placed while lab fabricates finals.' },
      { step: 'Fit & Cementation', desc: 'Final restorations tried in, adjusted, and permanently cemented.' },
    ],
  },
  {
    id: 'implants',
    title: 'Dental Implants',
    chip: 'Dental Implants',
    subtitle: 'Permanent Tooth Replacement Solution',
    color: '#00695C',
    dotColor: '#1565C0',
    icon: '🔩',
    duration: '2–3 visits',
    paragraphs: [
      'Dental implants are the gold standard for replacing missing teeth. A titanium post is surgically placed into the jawbone, integrating over weeks to form a permanent stable foundation for a crown that is indistinguishable from your natural teeth.',
      'Unlike bridges, implants do not require adjacent teeth to be filed down, and unlike dentures they require no adhesives or removal. They also stimulate the jawbone, preventing bone loss that causes facial ageing after tooth loss.',
      'We offer single implants, implant-supported bridges, implant-retained dentures, and full-arch solutions — all planned with CBCT 3D imaging for precision placement.',
    ],
    benefits: [
      'Permanent solution lasting a lifetime',
      'Same-Day Extraction, Implant Placement & Immediate Crowns for Front Teeth',
      'Looks and functions exactly like a natural tooth',
      'Preserves jawbone and prevents bone loss',
      'No impact on adjacent healthy teeth',
      'Full-arch solutions available',
      'Highest success rate of any tooth replacement',
    ],
    process: [
      { step: 'CBCT Bone Assessment', desc: 'Bone density, volume, and nerve positions mapped in 3D.' },
      { step: 'AI Guided Surgery', desc: 'AI-guided planning enhances precision, safety, and predictability throughout the implant procedure.' },
      { step: 'Implant Placement', desc: 'Titanium post placed surgically under local anaesthesia.' },
      { step: 'Osseointegration', desc: '8–12 weeks for implant to fully fuse with surrounding bone.' },
      { step: 'Abutment Fitting', desc: 'Connector piece attached to the integrated implant.' },
      { step: 'Crown Placement', desc: 'Custom ceramic crown fitted, adjusted, and finalised.' },
    ],
  },
  {
    id: 'orthodontics',
    title: 'Orthodontics',
    chip: 'Orthodontics',
    subtitle: 'Braces, Clear Aligners & Bite Correction',
    color: '#1976D2',
    dotColor: '#2ECC71',
    icon: '😁',
    duration: 'Ongoing',
    paragraphs: [
      'Orthodontic treatment at Noble Dental Surgery covers the full spectrum of tooth and jaw alignment — from simple crowding and spacing issues to complex skeletal discrepancies requiring combination therapy.',
      'We offer traditional metal braces, clear ceramic braces, lingual braces fitted behind the teeth, and clear aligner therapy for patients who prefer a virtually invisible option with fewer clinic visits and complete treatment plan designed upfront',
      'Our in-house orthodontist provides continuity of care from initial records through to retention — no referrals, no delays, and seamless coordination with our other specialties.',
    ],
    benefits: [
      'Metal, ceramic, and lingual brace options',
      'Clear aligner therapy — fewer clinic visits and complete treatment plan designed upfront',
      '3D digital scan and treatment preview upfront',
      'In-house specialist for full continuity of care',
      'Interceptive orthodontics from age 7',
      'Retention planning included in every case',
    ],
    process: [
      { step: 'Records & Diagnosis', desc: '3D scan, photographs, and cephalometric analysis completed.' },
      { step: 'Treatment Simulation', desc: 'Digital preview of projected tooth movement shown to patient.' },
      { step: 'Appliance Fitting', desc: 'Brackets bonded or first set of aligners delivered.' },
      { step: 'Active Treatment', desc: 'Monthly reviews to monitor and adjust tooth movement.' },
      { step: 'Retention', desc: 'Fixed or removable retainer fitted to hold final position.' },
    ],
  },
  {
    id: 'omfs',
    title: 'Oral & Maxillofacial Surgery',
    chip: 'Oral & Maxillofacial Surgery',
    subtitle: 'Surgical Expertise for Complex Dental Needs',
    color: '#B71C1C',
    dotColor: '#2ECC71',
    icon: '🏥',
    duration: '30–120 min',
    paragraphs: [
      'Our oral and maxillofacial surgery team handles the full range of surgical dental procedures — from routine wisdom tooth extractions to complex jaw surgery, bone grafting, and surgical implant placements.',
      'All surgical procedures are performed under appropriate anaesthesia. For anxious patients or complex cases, IV sedation is available, ensuring a comfortable, controlled experience throughout.',
      'We work in close coordination with our implant, orthodontic, and prosthodontic teams to deliver integrated surgical-restorative treatment.',
    ],
    benefits: [
      'Wisdom tooth surgical extractions',
      'Treating fractures of jaw bones and facial trauma',
      'Bone grafting for implant site preparation',
      'Jaw surgery for skeletal discrepancies',
      'Cyst and tumour removal',
      'IV sedation for anxious patients',
      'Collaborative surgical-restorative planning',
    ],
    process: [
      { step: 'Surgical Consultation', desc: 'Clinical and radiographic assessment with full risk discussion.' },
      { step: 'Pre-operative Planning', desc: 'CBCT imaging and surgical stent fabrication if required.' },
      { step: 'Anaesthesia', desc: 'Local, sedation, or general anaesthesia as appropriate.' },
      { step: 'Surgical Procedure', desc: 'Procedure performed with minimal trauma and precise technique.' },
      { step: 'Post-operative Care', desc: 'Aftercare instructions, medications, and follow-up scheduled.' },
    ],
  },
  {
    id: 'pediatric',
    title: 'Pediatric Dentistry',
    chip: 'Pediatric Dentistry',
    subtitle: 'Gentle Dental Care for Children',
    color: '#E65100',
    dotColor: '#1565C0',
    icon: '👶',
    duration: '30 min',
    paragraphs: [
      "At Noble Dental Surgery, we believe a child's first dental experiences shape their attitude towards oral health for life. Our child-friendly clinic and specialist paediatric dentists create a warm, fun, and completely anxiety-free environment.",
      'We see children from their very first tooth through to their teenage years, providing preventive care, early orthodontic monitoring, and parent education at every stage.',
      'Early intervention is central to our paediatric philosophy. Addressing small problems early prevents them becoming major issues — saving children from unnecessary treatment and cost as they grow.',
    ],
    benefits: [
      'Anxiety-free environment designed for children',
      'Preventive fissure sealants and fluoride',
      'Early detection of orthodontic issues from age 7',
      'Diet and brushing guidance for parents',
      'Pulp therapy to save primary teeth',
      'Space maintainers for premature tooth loss',
    ],
    process: [
      { step: 'Welcome Visit', desc: 'Child explores the clinic at their own comfortable pace.' },
      { step: 'Gentle Examination', desc: 'Teeth, gums, bite, and jaw development assessed carefully.' },
      { step: 'Prevention', desc: 'Cleaning, fluoride, and fissure sealants applied.' },
      { step: 'Child Education', desc: 'Interactive brushing technique demonstration.' },
      { step: 'Parent Guidance', desc: 'Diet advice and home care tips discussed with parents.' },
    ],
  },
  {
    id: 'periodontics',
    title: 'Periodontics',
    chip: 'Periodontics',
    subtitle: 'Gum Disease Treatment & Prevention',
    color: '#558B2F',
    dotColor: '#1565C0',
    icon: '🌿',
    duration: '45–90 min',
    paragraphs: [
      'Periodontics is the specialty concerned with the health of the gums and supporting bone structures around teeth. Gum disease is the leading cause of tooth loss in adults and has established links to systemic conditions.',
      'Our periodontist provides the full range of non-surgical and surgical gum treatments — from deep cleaning and root planing to periodontal surgery, regenerative procedures, and gum grafting.',
      'Periodontal maintenance is a lifelong commitment. Once active disease is controlled, we place patients on a customised supportive therapy programme to prevent recurrence.',
    ],
    benefits: [
      'Non-surgical deep scaling and root planing',
      'Periodontal surgery for advanced disease',
      'Bone regeneration using guided tissue techniques',
      'Gum grafting for recession and sensitivity',
      'Frenectomy for high frenum attachments',
      'Personalised maintenance programme',
    ],
    process: [
      { step: 'Periodontal Assessment', desc: 'Full pocket depth charting and bone level radiographs.' },
      { step: 'Non-surgical Therapy', desc: 'Thorough subgingival scaling and root surface debridement.' },
      { step: 'Re-evaluation', desc: 'Tissue response assessed 6–8 weeks after initial therapy.' },
      { step: 'Surgical Phase', desc: 'Periodontal surgery if non-surgical therapy insufficient.' },
      { step: 'Supportive Maintenance', desc: 'Regular 3–6 month reviews to sustain periodontal health.' },
    ],
  },
  {
    id: 'emergency',
    title: 'Emergency Dental Care',
    chip: 'Emergency Dental Care',
    subtitle: 'Same-Day Relief for Urgent Dental Problems',
    color: '#C62828',
    dotColor: '#1565C0',
    icon: '🚨',
    duration: 'Same day',
    paragraphs: [
      'Dental emergencies do not wait for convenient timing. Noble Dental Surgery reserves same-day emergency slots every day of the week so patients experiencing severe toothache, trauma, swelling, or a knocked-out tooth are seen promptly.',
      'Our emergency team manages the full range of urgent situations — from pain relief and temporary restorations to dental trauma, avulsed teeth, and acute oral infections requiring immediate drainage.',
      'When you call with a dental emergency, our team triages your situation over the phone, advises on immediate steps, and books you in at the earliest available slot — often the same day.',
    ],
    benefits: [
      'Same-day appointments for urgent cases',
      'Immediate pain relief as the first priority',
      'Management of knocked-out or broken teeth',
      'Acute abscess drainage and antibiotic prescription',
      'Temporary restorations to protect broken teeth',
      'Phone triage and first-aid advice immediately',
    ],
    process: [
      { step: 'Phone Triage', desc: 'Clinical team assesses urgency and advises on immediate care.' },
      { step: 'Emergency Slot', desc: 'Same-day appointment confirmed as quickly as possible.' },
      { step: 'Pain Management', desc: 'Immediate pain relief administered on arrival.' },
      { step: 'Emergency Treatment', desc: 'Definitive or temporary treatment to resolve the urgent issue.' },
      { step: 'Follow-up Plan', desc: 'Comprehensive follow-up treatment plan arranged.' },
    ],
  },
  {
    id: 'advanced',
    title: 'Advanced & Special Care',
    chip: 'Advanced & Special Care',
    subtitle: 'Specialist Care for Complex & Medically Compromised Patients',
    color: '#283593',
    dotColor: '#2ECC71',
    icon: '⚕️',
    duration: 'Varies',
    paragraphs: [
      'Some patients require additional consideration due to medical complexity, dental anxiety, physical disabilities, or special needs. Our advanced and special care service provides tailored treatment in a safe, supportive environment.',
      "We work closely with patients' medical teams where necessary, modifying treatment protocols for patients on anticoagulants, bisphosphonates, immunosuppressants, or those with complex systemic conditions.",
      'For patients with severe dental anxiety or needle phobia, we offer conscious sedation — allowing treatment to be completed comfortably for patients who would otherwise avoid essential dental care.',
    ],
    benefits: [
      'Dental care for medically complex patients',
      'IV conscious sedation for anxious patients',
      'Wheelchair-accessible facilities',
      'Specialist liaison with medical teams',
      'Treatment planning for oncology patients',
      'Sensory-adapted appointments available',
    ],
    process: [
      { step: 'Medical History Review', desc: 'Detailed assessment of medical conditions and medications.' },
      { step: 'MDT Liaison', desc: "Liaison with patient's medical team if clinically required." },
      { step: 'Modified Protocol', desc: "Treatment protocol adapted for patient's specific needs." },
      { step: 'Sedation if Required', desc: 'Conscious sedation administered for anxious or complex patients.' },
      { step: 'Recovery & Follow-up', desc: 'Post-treatment monitoring and personalised recall plan.' },
    ],
  },
  {
    id: 'nextgen',
    title: 'Next Gen Dental Solutions',
    chip: 'Next Gen Dental Solutions',
    subtitle: 'AI-Powered Diagnostics & Digital Dentistry',
    color: '#00838F',
    dotColor: '#1565C0',
    icon: '🤖',
    duration: 'Varies',
    paragraphs: [
      'Noble Dental Surgery is one of the very few clinics in Punjab to house the ScanO Self-Diagnostic Robot — a revolutionary AI-powered system providing instant dental checkups with high-resolution images and detailed reports to your smartphone.',
      'Our 3Shape Intraoral Scanner brings sub-millimetre digital precision to every procedure — from designing your perfect smile to scanning jaws for crowns, bridges, implants, and aligners, eliminating traditional impressions entirely.',
      'These technologies enable earlier diagnosis, more conservative treatment planning, and better patient outcomes — preserving more natural tooth structure and reducing the complexity and cost of future treatment.',
    ],
    benefits: [
      'ScanO AI robot for instant self-diagnostic checkups',
      'Smartphone reports from ScanO within minutes',
      '3Shape intraoral scanner for digital impressions',
      'AI-assisted smile design with digital preview',
      'Eliminates discomfort of traditional impressions',
      'Earlier diagnosis — smaller, less invasive treatment',
    ],
    process: [
      { step: 'ScanO Diagnostic Scan', desc: 'AI robot captures high-resolution images of all teeth and gums.' },
      { step: 'Instant AI Report', desc: 'Personalised report with treatment suggestions sent to your phone.' },
      { step: 'Intraoral Scanning', desc: '3Shape scanner creates a precise 3D digital model of your mouth.' },
      { step: 'Digital Treatment Plan', desc: 'Treatment visualised digitally — you see the outcome before it begins.' },
      { step: 'Precision Execution', desc: 'Digital data guides clinical procedures for optimal accuracy.' },
    ],
  },
];

export const SERVICES_DETAIL = RAW_SERVICES.map((service) => ({
  ...service,
  image: SERVICE_IMAGES[service.id] || main,
  imageAlt: `${service.title} at Noble Dental Surgery, Hoshiarpur`,
  imageLeft: IMAGE_LEFT_IDS.has(service.id),
}));

export const getServiceById = (id) =>
  SERVICES_DETAIL.find((s) => s.id === id) ?? SERVICES_DETAIL[0];
